export default "__VITE_ASSET__CKTC9LSc__"